import { motion } from "framer-motion";

/**
 * ReviewProgressTrack — "Where your campaign is." Three steps as one stepper:
 * a full-width palette bar (solid = done, solid + pulse = happening now,
 * hollow colour outline = up next), the state word, a serif title, one line.
 * Enrollment can be verified ahead of approval from the admin Enrollment tab.
 */
const STEPS = [
  { key: "enrollment", title: "Enrollment check", body: "We confirm you're actively enrolled. Approving your campaign records this for our audit trail.", bg: "bg-cobalt", text: "text-cobalt", ring: "border-cobalt/40" },
  { key: "review", title: "Page review", body: "A reviewer reads your bio, funding need, photos and video the way a donor would.", bg: "bg-tangerine", text: "text-tangerine", ring: "border-tangerine/50" },
  { key: "live", title: "Your page goes live", body: "You'll get an email with your campaign link.", bg: "bg-grass", text: "text-grass", ring: "border-grass/50" },
];

const WORD = { done: "Done", now: "Happening now", next: "Up next" };

export const ReviewProgressTrack = ({ enrollmentVerified, payoutsDone = false, live = false }) => {
  const stateOf = (i) => {
    if (live) return "done";
    if (i === 0) return enrollmentVerified ? "done" : "now";
    if (i === 1) return enrollmentVerified ? "now" : "next";
    return "next";
  };
  return (
    <div data-testid="review-progress-track">
      <h2 className="font-serif text-3xl leading-tight text-ink">Where your campaign is.</h2>
      <ol className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-3">
        {STEPS.map((s, i) => {
          const st = stateOf(i);
          return (
            <motion.li
              key={s.key}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: 0.5 + i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`review-step-${s.key}`}
              data-state={st}
            >
              <span aria-hidden="true" className={`block h-2.5 w-full rounded-full ${st === "next" ? `border-2 ${s.ring}` : s.bg} ${st === "now" ? "animate-pulse" : ""}`} />
              <p className={`mt-4 text-[13px] font-semibold ${st === "next" ? "text-olive" : s.text}`}>{WORD[st]}</p>
              <h3 className="mt-1 font-serif text-3xl leading-tight text-ink">{s.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-olive">
                {s.body}
                {s.key === "live" && !payoutsDone && " Finish Stripe payout setup any time from here."}
              </p>
            </motion.li>
          );
        })}
      </ol>
    </div>
  );
};
